// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"p9JTM","activeMonthBox":"_1ObEy","wrap":"mxiBN","months":"HPImh","month":"dYw6I","year":"rSJPT","skeleton-progress":"p2nM-"};